"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeader = exports.RotaNewModal = void 0;
const react_1 = __importDefault(require("react"));
const button_icon_1 = __importDefault(require("../button-icon"));
const background_modal_1 = __importDefault(require("../background-modal"));
const new_modal_1 = __importStar(require("./new-modal"));
exports.RotaNewModal = new_modal_1.default;
Object.defineProperty(exports, "ModalHeader", { enumerable: true, get: function () { return new_modal_1.ModalHeader; } });
const style_1 = require("./style");
const RotaModal = ({ isLoading = false, onClose, color, children, name, onEdit, onDelete, onBack, isSmall = false, styles }) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(background_modal_1.default, { handleClose: onClose },
            react_1.default.createElement(react_1.default.Fragment, null, !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(style_1.Content, { isSmall: isSmall, color: color, style: styles, onClick: e => e.stopPropagation() },
                    react_1.default.createElement(style_1.StyledWrapModalHeader, null,
                        react_1.default.createElement(style_1.StyledWrapIcons, null,
                            onBack && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(button_icon_1.default, { icon: "arrowLeft", onClick: onBack }),
                                react_1.default.createElement(style_1.StyledDivider, null))),
                            react_1.default.createElement(style_1.StyledWrapName, { isSmallMargin: !!onBack }, name)),
                        react_1.default.createElement(style_1.StyledWrapIcons, null,
                            onEdit && (react_1.default.createElement(button_icon_1.default, { icon: "edit", onClick: onEdit, style: { marginRight: "11px" } })),
                            onDelete && (react_1.default.createElement(button_icon_1.default, { icon: "delete", onClick: onDelete, style: { marginRight: "11px" } })),
                            onClose && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(style_1.StyledDivider, null),
                                react_1.default.createElement(button_icon_1.default, { icon: "close", onClick: onClose }))))),
                    isSmall && (react_1.default.createElement(style_1.StyledSmallWrapChildren, null, children)),
                    !isSmall && (react_1.default.createElement(style_1.StyledWrapChildren, null, children)))))))));
};
exports.default = RotaModal;
